import React from "react";

export default class BlockHowToGuides extends React.Component  
{
    constructor(props)    
    {
        super(props);

        this.env = this.props.env;

        this.requestImageFile = require.context('../images/icons', true, /.png$/);       
        
        this.dumpster_items = 
        [
            {
                'href' : 'blog/dumpster-rental-101',
                'image' : `./getting-started.png`, 
                'title' : 'GETTING STARTED',
                'text' : 'Dumpster rental 101 begins'
            },
            {
                'href' : 'blog/the-ultimate-guide-to-dumpster-sizes',
                'image' : `./sizes.png`,
                'title' : 'SIZES',
                'text' : 'Ask for the right dumpster size'
            },
            {
                'href' : 'blog/roll-off-dumpster-prices',
                'image' : `./prices.png`,
                'title' : 'PRICES',
                'text' : 'Lower your cost to rent'
            },
            {
                'href' : 'blog/what-can-i-put-in-a-dumpster',
                'image' : `./debris.png`,
                'title' : 'Debris',
                'text' : "What can and can't go in a dumpster"
            },
            {
                'href' : 'blog/dumpster-rental-terms-and-conditions-a-closer-look-at-the-fine-print',
                'image' : `./rental-terms.png`,
                'title' : 'RENTAL TERMS',
                'text' : "Understand what you're agreeing to"
            },
            {
                'href' : 'blog/hiring-the-right-dumpster-service-everything-you-need-to-know',
                'image' : `./service.png`,
                'title' : 'SERVICE',
                'text' : 'Comparing dumpster services'
            },
            {
                'href' : 'blog/rent-a-dumpster-or-hire-a-junk-removal-company',
                'image' : `./options.png`,
                'title' : 'OPTIONS',
                'text' : 'Rent a dumpster or hire junk removal'
            }
        ]; 

        this.demolition_items =
        [
            {
                'href' : 'blog/getting-started-with-demo',
                'image' : `./demolition-started.png`, 
                'title' : 'GETTING STARTED',
                'text' : 'Demolition 101 begins'
            },
            {
                'href' : 'blog/how-much-does-demolition-cost-per-square-foot',
                'image' : `./demolition-cost.png`, 
                'title' : 'Demolition Cost',
                'text' : 'Understanding quotes and prices'
            },
            {
                'href' : 'blog/barn-demolition-and-deconstruction-process',
                'image' : `./demolition-barn.png`, 
                'title' : 'Barn Removal',
                'text' : 'How it works and how much it costs'
            },
            {
                'href' : 'blog/concrete-demolition-removal-everything-homeowners-need-to-know',
                'image' : `./demolition-barn.png`, 
                'title' : 'Concrete Removal',
                'text' : 'See removal processes and pricing'
            },
            {
                'href' : 'blog/the-homeowners-guide-to-demolishing-a-house',
                'image' : `./demolition-house.png`, 
                'title' : 'House Demolition',
                'text' : "How it's done and how much it costs"
            },
            {
                'href' : 'blog/the-homeowners-guide-to-demolishing-a-house',
                'image' : `./demolition-interior.png`, 
                'title' : 'Interior Demolition',
                'text' : "Kitchens, bathrooms, basements, and more"
            },
            {
                'href' : 'blog/homeowners-guide-to-mobile-home-removal',
                'image' : `./demolition-home_mobile.png`, 
                'title' : 'Mobile Home Removal',
                'text' : "Demolition, relocation, costs, etc."
            },
            {
                'href' : 'blog/the-homeowners-guide-to-swimming-pool-demolition-and-removal',
                'image' : `./demolition-pool_removal.png`, 
                'title' : 'Pool Removal',
                'text' : "Learn about removal methods and pricing"
            },
            {
                'href' : 'blog/homeowners-guide-to-underground-oil-tank-removal',
                'image' : `./demolition-tank_removal.png`, 
                'title' : 'Tank Removal',
                'text' : "Under and aboveground tank removal"
            },
            {
                'href' : 'blog/an-introduction-to-chimney-removal',
                'image' : `./demolition-chimney_removal.png`, 
                'title' : 'Chimney Removal',
                'text' : "Discover removal processes and costs"
            }
        ];
        
        this.items = this.props.env.site === 'dumpster' ? this.dumpster_items : this.demolition_items;
        this.classes = this.props.env.site === 'dumpster' ? 'block how-to-guides' : 'block how-to-guides demolition';
    }
    
    render()
    {
        return (
            <div className={this.classes}>
                <h2>How-To Guides</h2>
                <div className="provider-card card">    
                    <ul className="items-list">
                    {                       
                        this.items.map((item, index) => 
                        {           
                            return (
                                <li key={index} className="item">
                                    <a href={'/'+item.href}>
                                        <span className="icon" style={{ backgroundImage: `url(${this.requestImageFile(item.image)})` }}></span>
                                        <div className="item-text">
                                            <h5>{item.title}</h5>
                                            <h6>{item.text}</h6>
                                        </div>
                                    </a>
                                </li>
                            )
                        })
                    }   
                    </ul>                    
                </div>
            </div>
        )
    }
};